var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPopOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Templates",
    transform: "translate(-511.000000, -816.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-pop-out",
    transform: "translate(512.000000, 817.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,4 L8,7.5 C8,7.776 7.776,8 7.5,8 L0.5,8 C0.224,8 0,7.776 0,7.5 L0,0.5 C0,0.224 0.224,0 0.5,0 L4,0",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8 3 8 0 5 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L2.5,5.5",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopOut);
export default __webpack_public_path__ + "static/media/icon-pop-out.58be06bba3645460e1dbbdd7944a8362.svg";
export { ForwardRef as ReactComponent };